// Vuex connections module main file

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  filteringCriteria: {},
  list: {
    records: [],
    total: 0,
    page: 1,
  },
};

const getters = {
  list: state => state.list,
  filteringCriteria: state => state.filteringCriteria,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
